package presentation.screens.forgotPassword

import com.kinoshazam.Navigator
import com.kinoshazam.model.Route
import data.LoginRepository
import org.koin.core.component.KoinComponent
import presentation.screens.forgotPassword.ForgotPasswordMVIAction.*
import presentation.screens.otp.OtpState
import utils.BaseViewModel
import utils.Patterns
import utils.launch

class ForgotPasswordViewModel(
    private val loginRepository: LoginRepository,
    private val navigator: Navigator,
) : BaseViewModel<ForgotPasswordState, ForgotPasswordMVIAction>(), KoinComponent {


    override fun initState(): ForgotPasswordState = ForgotPasswordState()

    override fun onAction(action: ForgotPasswordMVIAction) {
        when (action) {
            is SendClicked -> onSend()
            is BackClicked -> navigator.back()
            is EmailChanged -> updateState { copy(email = action.email, isEmailError = false) }
            is ErrorDismissed -> updateState { copy(isError = false) }
        }
    }

    private fun onSend() {
        if (!isValid()) return
        updateState { copy(isLoading = true) }
        launch(onError = {
            updateState { copy(isError = true, isLoading = false) }
        }) {
            loginRepository.requestPasswordReset(stateValue.email)
            navigator.navigateTo(
                Route.Dialog.OtpScreen(
                    email = stateValue.email,
                    flowType = OtpState.OtpFlowType.Password.name,
                )
            )
            updateState { copy(isLoading = false) }
        }
    }

    private fun isValid(): Boolean {
        val email = stateValue.email
        val isEmailValid = email.isNotEmpty() && Patterns.EMAIL_ADDRESS.matches(email)

        return if (!isEmailValid) {
            updateState { copy(isEmailError = !isEmailValid) }
            false
        } else {
            true
        }
    }
}
